import { RouteObject } from 'react-router-dom'
import { Brands } from './brands'
import { BrandsAll } from './brands-all'
import { BrandDetails } from './brand-details'

export const BrandsRoute: RouteObject[] = [
    {
        path: '/brands',
        element: <Brands />,
        children: [
            {
                index: true,
                element: <BrandsAll />,
            },
            {
                path: ':brandname',
                element: <BrandDetails />,
            },
        ],
    },
]
